// extracted by mini-css-extract-plugin
export default {"wrap":"MealComponent_wrap__U8XWW","title":"MealComponent_title__77Z5Y","blockButton":"MealComponent_blockButton__ucQZB"};